import script from "./ErrorHandle.vue?vue&type=script&lang=ts"
export * from "./ErrorHandle.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__